import {
  ActionsObservable,
  StateObservable,
  combineEpics,
  ofType,
} from 'redux-observable';
import { map } from 'rxjs/operators';
import { RootState } from 'src/root/store';

import { isCouncilOrgActiveSel } from '@shared/duck';
import { SET_ORGANIZATION } from '@shared/duck/actions';

import { reportsTabs } from '../constants';
import { epics as historyReportsEpics } from '../historyReports';
import { setActiveTab } from './actions';
import { activeTabSel } from './selectors';

const epics = [historyReportsEpics];

const setDefaultTab$ = (
  action$: ActionsObservable<{ type: typeof SET_ORGANIZATION }>,
  state$: StateObservable<RootState>,
) =>
  action$.pipe(
    ofType(SET_ORGANIZATION),
    map(() => {
      const state = state$.value;
      const isCouncil = isCouncilOrgActiveSel(state);
      const prevActiveTab = activeTabSel(state);

      const activeTab = isCouncil ? reportsTabs.COUNCIL : reportsTabs.BASIC;
      return activeTab !== prevActiveTab
        ? setActiveTab(activeTab)
        : { type: '@@noop' };
    }),
  );

export default combineEpics(...epics, setDefaultTab$);
